import { Component, input } from '@angular/core';
import { RdsButtonModule } from '@rds/angular-components';
import { BUTTON_TEXTS } from '../../../constants/buttons.constants';

@Component({
  selector: 'inexp-teaser-card',
  imports: [RdsButtonModule],
  templateUrl: './teaser-card.component.html',
  styleUrl: './teaser-card.component.scss',
})
export class TeaserCardComponent {
  title = input<string>();
  description = input<string>();
  primaryBtn = input<string>();
  secondaryBtn = input<string>();

  readonly BUTTONS = BUTTON_TEXTS;

  openExternal(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
